import React from "react";
import { PatternFormat } from "react-number-format";

export const PhoneNumberFormattedInputInner = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <PatternFormat   
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      format="(###) ### ####"
      allowemptyformatting="true"
      mask="#"
    />
  );
};

const PhoneNumberFormattedInput = React.forwardRef((props, ref) => {
  return <PhoneNumberFormattedInputInner {...props} inputRef={ref} />;
});

export default PhoneNumberFormattedInput;
